import {pathToRegexp} from "path-to-regexp";

export default function matchRoute (routes, pathname) {
  if (!routes.length) return null;
  
  return routes.find((route) => {
    const regex = pathToRegexp(route.path);
    return regex.test(pathname);
  });
};